export type Lang = 'en' | 'ar';

const en = {
  title: 'Download the app',
  subtitle:
    'Install the official app on your phone, Android TV or Fire TV, then enter your store code.',
  android_mobile: 'Android phone and tablet',
  android_tv: 'Android TV',
  fire_tv: 'Amazon Fire TV',
  download: 'Download APK',
  version: 'Version {v}',
  size: 'Size {s}',
  published: 'Published {d}',
  checksum: 'SHA-256 checksum',
  notes: "What's new",
  unavailable: 'Not available yet.',
  loadError: 'Could not load downloads. Check your connection and try again.',
  retry: 'Try again',
  loading: 'Loading…',
  howTitle: 'How to install',
  howPhone:
    'Open the downloaded file. If Android asks, allow your browser to install unknown apps for this one install.',
  howTv:
    'On Android TV, open Settings → Device preferences → Security and allow your file manager or browser to install apps, then open the file.',
  howFire:
    'On Fire TV, enable Developer options → Install unknown apps for the app you use to download (for example a browser or the Downloader app), then enter this page address in it.',
  storeHint: 'After installing, open the app and enter the store code your provider gave you.',
  storeCode: 'Your store code: {code}',
  legal:
    'This app plays only content your provider is licensed to offer. It does not include any channels or media.',
  language: 'العربية',
};

export type Strings = typeof en;

const ar: Strings = {
  title: 'حمّل التطبيق',
  subtitle: 'ثبّت التطبيق الرسمي على هاتفك أو Android TV أو Fire TV، ثم أدخل رمز المتجر.',
  android_mobile: 'هاتف أو تابلت Android',
  android_tv: 'Android TV',
  fire_tv: 'Amazon Fire TV',
  download: 'تحميل APK',
  version: 'الإصدار {v}',
  size: 'الحجم {s}',
  published: 'نُشر في {d}',
  checksum: 'بصمة SHA-256',
  notes: 'الجديد',
  unavailable: 'غير متاح بعد.',
  loadError: 'تعذّر تحميل الروابط. تحقق من الاتصال وحاول مرة أخرى.',
  retry: 'إعادة المحاولة',
  loading: 'جارٍ التحميل…',
  howTitle: 'طريقة التثبيت',
  howPhone:
    'افتح الملف بعد تحميله. إذا طلب Android ذلك، اسمح للمتصفح بتثبيت التطبيقات غير المعروفة لهذا التثبيت.',
  howTv:
    'في Android TV افتح الإعدادات ← تفضيلات الجهاز ← الأمان واسمح لمدير الملفات أو المتصفح بتثبيت التطبيقات، ثم افتح الملف.',
  howFire:
    'في Fire TV فعّل خيارات المطوّر ← تثبيت التطبيقات غير المعروفة للتطبيق الذي ستحمّل به (مثل المتصفح أو تطبيق Downloader)، ثم أدخل عنوان هذه الصفحة فيه.',
  storeHint: 'بعد التثبيت افتح التطبيق وأدخل رمز المتجر الذي أعطاك إياه مزوّد الخدمة.',
  storeCode: 'رمز متجرك: {code}',
  legal:
    'يعرض هذا التطبيق فقط المحتوى المرخّص لمزوّد خدمتك. لا يحتوي التطبيق على أي قنوات أو وسائط.',
  language: 'English',
};

export const STRINGS: Record<Lang, Strings> = { en, ar };

export function pickLanguage(
  query: string | null,
  stored: string | null,
  navigatorLanguages: readonly string[],
): Lang {
  for (const candidate of [query, stored, ...navigatorLanguages]) {
    const base = candidate?.toLowerCase().split('-')[0];
    if (base === 'ar' || base === 'en') return base;
  }
  return 'en';
}

export function fill(template: string, values: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => values[k] ?? m);
}
